
















































































// vue
import {
    defineComponent,
    ref,
    onMounted,
    computed,
} from '@vue/composition-api';

// services
import { useService } from '@/vue3/api/services';

// hooks
import { useGeoRecord } from '@/vue3/hooks/geoRecordHook';
import { useColor } from '@/vue3/hooks/colorHook';

// sotre
import { useStore } from '@/store';

// primevue
import Listbox from 'primevue/listbox';
import ProgressSpinner from 'primevue/progressspinner';
import Tree from 'primevue/tree';
import Button from 'primevue/button';

export default defineComponent({
    components: {
        Listbox,
        ProgressSpinner,
        Tree,
        Button,
    },
    props: {
        geoRecord: {
            type: Object,
            default: () => {},
        },
        handleGeoRecordPropertyUpdate: {
            type: Function,
            default: () => {},
        },
        isLoading: {
            type: Boolean,
            default: false,
        },
        categorySummaries: {
            type: Array,
            default: () => [],
        },
        value: {
            type: Object,
            default: () => {},
        },
        isMobile: {
            type: Boolean,
            default: false,
        },
    },
    setup(props: any) {
        // refs
        const selectedNode = ref();
        const nodes = ref();
        const categories = ref<any[]>([]);

        // hooks
        const { getAllGeoRecordCategoryAsTreeByRole } = useService();
        const { categoriesToArray } = useGeoRecord();
        const { isLight } = useColor();
        const store = useStore();

        // computed
        const loadingCategories = computed(() => {
            if (props.isLoading) {
                return true;
            }
            return props.categorySummaries.length <= 0;
        });

        const selectedCategory = computed(() => {
            if (categories.value) {
                return categories.value.find(
                    (x) => x.id === props.value?.geoRecordCategoryId,
                );
            } else {
                return defaultCategory;
            }
        });

        const defaultCategory = computed(() => {
            return categories.value.find((x:any) => x.label === 'No Category');
        });

        // methods
        const onNodeSelected = (node) => {
            selectedNode.value = {
                id: node.id,
                checked: true,
            };
            props.handleGeoRecordPropertyUpdate({geoRecordCategoryId: node.id})
        };

        const sortCatrgoryTreeOrder = async (nodes: any) => {
            for (let node of nodes) {
                if (node.children && node.children.length > 0) {
                    await sortCatrgoryTreeOrder(node.children);
                }
            }
            nodes.sort((a: any, b: any) => a.label.localeCompare(b.label));
        };

        const getGeoRecordCategoryAsTree = async (): Promise<void> => {
            nodes.value = await getAllGeoRecordCategoryAsTreeByRole(
                store.getters.account.roleId,
            );
            sortCatrgoryTreeOrder(nodes.value);

            categories.value = categoriesToArray(nodes.value);
        };

        // lifecycle
        onMounted(async () => {
            await getGeoRecordCategoryAsTree();
        });

        return {
            loadingCategories,
            nodes,
            selectedNode,
            selectedCategory,
            onNodeSelected,
            isLight,
            defaultCategory,
        };
    },
});
